import React, { useState } from "react";
import { Grid, Stack } from "@mui/material";
import Icon from "src/components/icon";
import styled from "styled-components";
import Link from "src/components/link";
import github from "src/assets/icons/github";
import { LoadingButton } from "@mui/lab";
import request from "../../../utils/request";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.h2`
    font-size: 12px;
    font-weight: normal;
    margin: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
        width: 60%;
    }
    color: ${({ theme }) => theme.palette.secondary.main};
`;

const PermissionsIcon = styled(Icon)`
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const ContactPlaceholder =
    "In case of any inquiry regarding software permissions, please do not hesitate to ";

const PermissionsGithubApp = () => {
    const [loading, setLoading] = useState(true);
    const [appPublicLink, setAppPublicLink] = useState();

    const getUrl = async () => {
        try {
            const { publicLink } = await request("api/github/app/public-link");
            setAppPublicLink(publicLink);
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        getUrl();
    }, []);

    return (
        <Grid container justifyContent="center" mb={4}>
            <Stack
                direction="column"
                alignItems="flex-start"
                style={{ height: "100%", width: "90%" }}
            >
                <H1>Github Integration</H1>
                <H2>What adadot does with your Github data</H2>
                <PermissionsIcon svg={github} width="100px" height="127" />
                <P style={{ marginTop: "12px", fontWeight: "200" }}>
                    {ContactPlaceholder}
                    <Link to="/upgrade/inquiry">contact us</Link>
                </P>
                <Stack mt={4} mb={4} direction="row" spacing={2}>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        type="submit"
                        loading={loading}
                        href={
                            appPublicLink && appPublicLink.endsWith("/")
                                ? `${appPublicLink}installations/new`
                                : `${appPublicLink}/installations/new`
                        }
                        style={{ width: "102px" }}
                    >
                        Continue
                    </LoadingButton>
                    <LoadingButton
                        variant="contained"
                        color="secondary"
                        type="submit"
                        loading={loading}
                        href="mailto:info@adadot.com"
                    >
                        Contact us to set it up
                    </LoadingButton>
                </Stack>
            </Stack>
        </Grid>
    );
};

export default PermissionsGithubApp;
